var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"translate",rawName:"v-translate"}],staticClass:"button is-outlined",attrs:{"disabled":false},on:{"click":function($event){return _vm.disconnectAction()}}},[_vm._v("\n  Disconnect customer\n")])}
var staticRenderFns = []

export { render, staticRenderFns }